import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

function SkeletonEffect(props) {
    const { width, height, count, className } = props;
  return (
    <SkeletonTheme baseColor="#859318" highlightColor="#fff">
        <div style={{width: '100%'}}>
                <Skeleton className={className} style={{width: width, height: height}} count={count && count > 0 ? count : 1} /> 
            {/* <Skeleton className='' style={{width: width, height: height}} count={count && count > 0 ? count : 1} /> */}
        </div>
    </SkeletonTheme>
  )
}

export default SkeletonEffect